// src/TaskData.js
export const tasks = [
  {
    question: "What color do you get when you mix red and white?",
    options: ["Pink", "Purple", "Orange", "Green"],
    answer: "Pink",
  },
  {
    question: "Which shape has four equal sides?",
    options: ["Square", "Rectangle", "Triangle", "Circle"],
    answer: "Square",
  },
  {
    question: "What is the capital of France?",
    options: ["Berlin", "Madrid", "Paris", "Lisbon"],
    answer: "Paris",
  },
  {
    question: "Which number is the smallest?",
    options: ["7", "2", "10", "5"],
    answer: "2",
  },
  {
    question: "What fruit is known as the 'king of fruits'?",
    options: ["Mango", "Durian", "Banana", "Apple"],
    answer: "Durian",
  },
  {
    question: "What animal is known as the 'ship of the desert'?",
    options: ["Horse", "Camel", "Donkey", "Elephant"],
    answer: "Camel",
  },
  {
    question: "Which planet is known as the Red Planet?",
    options: ["Earth", "Mars", "Jupiter", "Saturn"],
    answer: "Mars",
  },
  {
    question: "How many legs does an octopus have?",
    options: ["6", "8", "10", "12"],
    answer: "8",
  },
  {
    question: "Which element has the chemical symbol 'O'?",
    options: ["Oxygen", "Gold", "Silver", "Hydrogen"],
    answer: "Oxygen",
  },
  {
    question: "In what year did the Titanic sink?",
    options: ["1912", "1905", "1898", "1920"],
    answer: "1912",
  },
  {
    question: "What is the largest mammal in the world?",
    options: ["Elephant", "Blue Whale", "Giraffe", "Great White Shark"],
    answer: "Blue Whale",
  },
  {
    question: "What is the main ingredient in guacamole?",
    options: ["Tomato", "Avocado", "Onion", "Pepper"],
    answer: "Avocado",
  },
  {
    question: "Which gas do plants absorb from the atmosphere?",
    options: ["Oxygen", "Carbon Dioxide", "Nitrogen", "Hydrogen"],
    answer: "Carbon Dioxide",
  },
  {
    question: "Which instrument has 88 keys?",
    options: ["Guitar", "Piano", "Violin", "Flute"],
    answer: "Piano",
  },
  {
    question: "What is the freezing point of water?",
    options: ["0°C", "32°F", "100°C", "212°F"],
    answer: "0°C",
  },
  {
    question: "Which country is known for the Great Wall?",
    options: ["India", "China", "Japan", "Korea"],
    answer: "China",
  },
  {
    question: "What color are emeralds?",
    options: ["Red", "Green", "Blue", "Yellow"],
    answer: "Green",
  },
  {
    question: "Who wrote 'Romeo and Juliet'?",
    options: ["Charles Dickens", "Mark Twain", "William Shakespeare", "Jane Austen"],
    answer: "William Shakespeare",
  },
  {
    question: "Which ocean is the largest?",
    options: ["Atlantic Ocean", "Indian Ocean", "Arctic Ocean", "Pacific Ocean"],
    answer: "Pacific Ocean",
  },
  {
    question: "What is the hardest natural substance on Earth?",
    options: ["Gold", "Iron", "Diamond", "Quartz"],
    answer: "Diamond",
  },
];
